import query from './query';
import { HeaderIcon } from '../HeaderIcon';
import { getBasket, getBasket_basket } from './__generated__/getBasket';
import styled from 'styled-components/macro';
import { useQuery } from '@apollo/client';
import { BasketHeader } from 'Ui/Icons/icons';
import AuthStore from 'Store/AuthStore';
import { allowedAllTypes } from 'Utils/memberTypes';
import { BasketBar } from '../BasketBar';
import { useEffect, useState } from 'react';

const StyledTimedBasket = styled.div<{
  cursor?: boolean;
  selected?: boolean;
  isBasket?: boolean;
}>`
  position: relative;
  cursor: pointer;
  /* BasketHeader est une icône en tracé (stroke), comme compte et wishlist :
     on force fill:none et on pilote la couleur via currentColor. Sans ça
     l'ancien style remplissait le tracé (grayUltraDark / --design-text-color)
     et le panier apparaissait en aplat noir dès qu'il contenait un article. */
  svg {
    color: ${({ isBasket }) =>
      isBasket ? 'var(--design-text-color)' : '#000'};
  }
  svg,
  svg path {
    fill: none !important;
  }
`;

const Label = styled.div<{ isBasket?: boolean }>`
  display: flex;
  justify-content: center;
  flex: 1;
  color: ${({ isBasket }) =>
    isBasket ? 'var(--design-text-color)' : 'var(--text-black, #000)'};
  font-family: var(--font-primary);
  font-size: 1.2rem;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.029px;
  position: absolute;
  width: 100%;
  font-weight: bolder;
  bottom: -13px;
`;

const ItemCount = styled.div`
  position: absolute;
  top: -0.6rem;
  left: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #000;
  background-color: rgb(223, 255, 109);
  font-family: var(--font-primary);
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 100%;
`;

const BasketHasItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
`;

const TimedBasket = ({
  basket,
  isBasket = false,
}: {
  basket: getBasket_basket;
  isBasket?: boolean;
}) => {
  const [barOpen, setBarOpen] = useState(false);
  const [localBasket, setLocalBasket] = useState<getBasket_basket>(basket);

  useEffect(() => {
    setLocalBasket(basket);
  }, [basket]);

  return (
    <>
      <StyledTimedBasket isBasket={isBasket} onClick={() => setBarOpen(true)}>
        <BasketHasItem>
          <BasketHeader width="20" height="20" />
          <ItemCount>{basket.productCount}</ItemCount>
        </BasketHasItem>
      </StyledTimedBasket>

      {barOpen && (
        <BasketBar
          basket={localBasket}
          onClose={() => setBarOpen(false)}
          onBasketUpdate={(updated) =>
            setLocalBasket(updated as getBasket_basket)
          }
        />
      )}
    </>
  );
};

export default ({ isBasket = false }: { isBasket?: boolean }) => {
  const sessionMemberType = AuthStore.useStoreState(
    (state) => state.sessionMemberType
  );
  const isMember = allowedAllTypes.includes(sessionMemberType);
  const { data } = useQuery<getBasket>(query, { skip: !isMember });
  const basket = data && data.basket;

  if (!basket || basket.productCount === 0) {
    return (
      <HeaderIcon>
        <BasketHeader width="20" height="20" />
      </HeaderIcon>
    );
  }

  return <TimedBasket basket={basket} isBasket={isBasket} />;
};
